import React, { useState } from 'react';

import NotifcationActions from '../../../common/flux/NotificationActions.js';
import Loader from '../../../common/components/notifications/Loader';
import Locations from './Locations';
import LocationCreate from './LocationCreate';
import MetadataFilter from '../MetadataFilter';
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent.js';
import schema from '../../../routes/permissions/schema.js';

const LocationListing = props => {
    const [term, setTerm] = useState('')
    const [isTyping, setIsTyping] = useState(false)
    const [createModal, setCreateModal] = useState(false)

    const termChanged = (term) => {
        setTerm(term)
        setIsTyping(false)
    }

    const handleTypingStarted = () => {
        setIsTyping(true)
    }

    const toggleCreateModal = (ev) => {
        ev && ev.preventDefault();
        setCreateModal(prev => !prev)
    }

    const save = (location) => {
        if (!valid(location)) return;
        toggleCreateModal();
        props.actions.add(location);
    }

    const valid = (location) => {
        var failed = []
        var messages = [];

        if (location.locationName === '') {
            failed.push('locationName');
            messages.push('Location Name is Required');
        }

        if (failed.length) {
            NotifcationActions.notify({
                type: 'warning',
                messages: messages
            });

            return false;
        }

        return true;
    }
    const renderLocations = () => {
        var listing = isTyping ?
            <Loader message='Filtering'/> :
            (<Locations
                {...props}
                mode={props.mode || 'manage'}
                locations={props.data}
                term={term.toLowerCase()}
            />)
        ;

        return (
            <div className="keyword-listing">
                <div className="callout clearfix">
                    <div className="col-md-8">
                        <MetadataFilter termChanged={termChanged} isTyping={handleTypingStarted}/>
                    </div>
                    <div className="col-md-4 text-right">
                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_LOCATIONS.CREATE}>
                            <button className="btn btn-primary" onClick={toggleCreateModal}>
                                <i className="fa fa-plus"/> Create Location
                            </button>
                        </RestrictedComponent>
                    </div>
                </div>

                <hr/>

                <div className="well">
                    {listing}
                </div>

                {renderModals()}
            </div>
        );
    }

    const renderModals = () => {
        if (createModal) {
            return <LocationCreate
                locations={props.data}
                save={save}
                createModal={createModal}
                toggleCreateModal={toggleCreateModal}/>;
        }
    }

    if (props.isResolving) return <Loader message='Fetching Locations' />;
    return renderLocations();
}

export default LocationListing;
